import { AjaxError } from 'rxjs/observable/dom/AjaxObservable';

export const extractMessage = (err : AjaxError) => {
  if (err.xhr && err.xhr.response && err.xhr.response.error) {
    return err.xhr.response.error;
  }else if (err.message) {
    return err.message;
  }
  return '';
};

export const getHttpHeaders = (authToken: string | undefined) => {
  const headers = {};
  headers['Authorization'] = `Bearer ${authToken}`;
  headers['Content-Type'] = 'application/json';
  return headers;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/epicCommon.ts